/**
 * MFS-5794: бесплатная ваза на странице товара зависит от выбранного размера.
 * Бейдж на фото (snippets/vase-badge.liquid) и чекбокс (snippets/free-vase-checkbox.liquid)
 * несут в data-free-vase-variants id размеров, которым ваза положена; при смене размера
 * прячем их на остальных. Подключается из обоих сниппетов — повторный запуск отсекается.
 */
(function () {
  if (window.freeVasePdpInit) return;
  window.freeVasePdpInit = true;

  const SELECTOR = {
    target: '[data-free-vase-variants]',
    variantSelection: '[data-variant-selection]',
    input: 'input[type="checkbox"]',
    form: (productId) => `[data-product-form][data-product-id="${productId}"]`,
  };

  function eligibleIds(target) {
    return (target.dataset.freeVaseVariants || '').split(',').filter(Boolean);
  }

  function update(target, variant) {
    const eligible = Boolean(variant) && eligibleIds(target).includes(String(variant.id));
    target.hidden = !eligible;
    if (eligible) return;

    // Галочка на неподходящем размере не должна дожить до «Add to cart». Вазу, которая уже
    // в корзине, не трогаем: она могла прийти с другим букетом, а без подходящего букета её
    // убирает корзина (sections/cart__main.liquid). Скрытый чекбокс commit() игнорирует.
    const input = target.querySelector(SELECTOR.input);
    if (input && input.checked && !(Number(target.dataset.quantityInCart) > 0)) {
      input.checked = false;
    }
  }

  function init() {
    const bound = new WeakSet();

    document.querySelectorAll(SELECTOR.target).forEach((target) => {
      const { productId } = target.dataset;
      if (!productId) return;

      document
        .querySelectorAll(`${SELECTOR.form(productId)} ${SELECTOR.variantSelection}`)
        .forEach((selection) => {
          if (bound.has(selection)) return;
          bound.add(selection);
          selection.addEventListener('variant-change', (event) => {
            const variant = event.detail && event.detail.variant;
            document
              .querySelectorAll(`${SELECTOR.target}[data-product-id="${productId}"]`)
              .forEach((el) => update(el, variant));
          });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
